export function ConversarIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6692 9.33329C12.6692 10.0686 12.0712 10.6666 11.3358 10.6666H4.66715C4.48982 10.6666 4.32049 10.7366 4.19582 10.862L3.33382 11.724V5.33329C3.33382 4.59796 3.93182 3.99996 4.66715 3.99996H11.3358C12.0712 3.99996 12.6692 4.59796 12.6692 5.33329V9.33329ZM11.3358 2.66663H4.66715C3.19649 2.66663 2.00049 3.86263 2.00049 5.33329V13.3333C2.00049 13.6026 2.16249 13.846 2.41182 13.9493C2.49449 13.9833 2.58115 14 2.66715 14C2.84049 14 3.01049 13.932 3.13849 13.8046L4.94315 12H11.3358C12.8065 12 14.0025 10.804 14.0025 9.33329V5.33329C14.0025 3.86263 12.8065 2.66663 11.3358 2.66663ZM10.6669 5.33329H5.33355C4.96555 5.33329 4.66689 5.63196 4.66689 5.99996C4.66689 6.36796 4.96555 6.66663 5.33355 6.66663H10.6669C11.0349 6.66663 11.3336 6.36796 11.3336 5.99996C11.3336 5.63196 11.0349 5.33329 10.6669 5.33329ZM9.33355 7.99996H5.33355C4.96555 7.99996 4.66689 8.29863 4.66689 8.66663C4.66689 9.03463 4.96555 9.33329 5.33355 9.33329H9.33355C9.70155 9.33329 10.0002 9.03463 10.0002 8.66663C10.0002 8.29863 9.70155 7.99996 9.33355 7.99996Z"
        fill="white"
      />
    </svg>
  );
}
